import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Layer, Box, Text, Button, Anchor } from 'grommet';
import { FormClose, Share } from 'grommet-icons';

import { toggleRealizationLayer } from '../actions/realization';

class RealizationComponent extends Component {
  render() {
    const {
      detail,
      toggleLayer,

      toggleRealizationLayer,
    } = this.props;

    if(toggleLayer && toggleLayer === 'realization') {
      return (
        <ResponsiveContext.Consumer>
          {size => (
            <Layer
              responsive={false}
              full='vertical'
              position='left'
              onClickOutside={toggleRealizationLayer}
              onEsc={toggleRealizationLayer}
            >
              <Box
                fill='vertical'
                width={ size === 'small' ? '80vw' : '55vw' }
                pad={{
                  top: 'large',
                  horizontal: 'large'

                }}
                gap='medium'
                overflow='auto'
                flex
              >
                {/* cabeçalho */}
                <Box
                  direction='row'
                  justify='between'
                  align='baseline'
                >
                  <Text
                    size={ size === 'small' ? 'large' : 'xlarge' }
                    textAlign={ size === 'small' ? 'start' : 'center' }
                  >
                    Sobre está enquete
                  </Text>

                  <Button
                    plain
                    title='Fechar'
                    icon={<FormClose />}
                    onClick={toggleRealizationLayer}
                  />
                </Box>

                {/* conteúdo */}
                <Box
                  gap='large'
                >
                  <Text color='dark-2' size='small'>
                    Esta enquete utiliza o sistema <Anchor href='https://gerenciameumandato.com.br' target='_blank'>Gerencia Meu Mandato <Share color='brand' size='small' /></Anchor>, que disponibiliza a plataforma, mas não é responsável pelo seu conteúdo ou pelas decisões relacionadas à sua utilização.
                  </Text>

                  <Box
                    border={{
                      color: 'light-4'
                    }}
                    round='small'
                    pad={{
                      vertical: 'medium',
                      horizontal: 'medium',
                    }}
                    gap='xxsmall'
                    direction={ size === 'small' || size === 'medium' ? 'column' : 'row' }
                    justify='between'
                  >
                    <Box>
                      <Text color='dark-2' size='xsmall'>
                        Enquete criada e gerenciada por:
                      </Text>
                    </Box>

                    <Box
                      gap='xsmall'
                    >
                      <Box>
                        <Text color='dark-1' size='medium'>
                          {detail.displayName}
                        </Text>
                      </Box>

                      <Box>
                        <Text color='graph-3' size='small'>
                          {detail.displayEmail}
                        </Text>

                        <Text color='dark-5' size='small'>
                          {detail.displayPhoneNumber}
                        </Text>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Layer>
          )}
        </ResponsiveContext.Consumer>
      )
    }

    return null;
  }
}

const mapStateToProps = ({ homeReducer: { layer, detailLayer } }) => ({
  detail: detailLayer.detail,
  toggleLayer: layer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    toggleRealizationLayer,
  }, dispatch);

export const Realization = connect(mapStateToProps, mapDispatchToProps)(RealizationComponent);
